import { render, staticRenderFns } from "./HerbIdealEditor.vue?vue&type=template&id=4b912026&scoped=true"
import script from "./HerbIdealEditor.vue?vue&type=script&lang=js"
export * from "./HerbIdealEditor.vue?vue&type=script&lang=js"
import style0 from "./HerbIdealEditor.vue?vue&type=style&index=0&id=4b912026&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b912026",
  null
  
)

export default component.exports